//import { ListViewProvider, useListView } from './core/ListViewProvider'
import { useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { KTSVG } from '../../_metronic/helpers'
import { Modal } from 'react-bootstrap'

const editUserSchema = Yup.object().shape({
    company_status: Yup.string().trim().required('Status is required'),
    remarks: Yup.string().trim().required('Remarks is required'),
})

/**
 * DownloadButton component for downloading files with remarks and confirmation.
 * - Renders a modal form for entering remarks before download.
 * - Uses Formik and Yup for form state, validation, and submission.
 * - Handles confirmation dialog and API call for file download.
 */
const DownloadButton = ({ DownloadApi, className }) => {


    const [isModalOpen, setIsModalOpen] = useState(false);

    const formik = useFormik({
        initialValues: {},
        validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true)

        }
    })
    // const submitApi = () => {
    //     let values = formik.values;
    //     values.previewUrl = null;
    //     let formData = new FormData();
    //     for (let value in values) {
    //         if (values[value] !== undefined && values[value] !== null)
    //             formData.append([value], values[value]);
    //     }
    //     try {
    //         if (isNotEmpty(values.id)) {
    //             // uploadApi(formData, values.id)
    //         } else {
    //             // uploadApi(formData)
    //             formik.resetForm()
    //         }
    //     } catch (ex) {
    //         console.error(ex)
    //     } finally {
    //         formik.setSubmitting(true)

    //     }
    // }
    const confirmationPopup = (type) => {
        setIsModalOpen(type)
    }
    return (<>
        {/*begin::General options*/}

        <button type='button' onClick={() => confirmationPopup(true)} className={className}>
            {/* <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-2 ' /> */}
            Download
        </button>
        <Modal className={'modal-lg'} show={isModalOpen} onHide={() => setIsModalOpen(false)}>
            <Modal.Header className='h-20px' closeButton>  <h4 className="fw-semibold fs-5 py-1"> Download File </h4></Modal.Header>
            <Modal.Body>
                <div className='px-5'>

                    <form id="kt_ecommerce_add_FAQ_form" className="form fv-plugins-bootstrap5 fv-plugins-framework" onSubmit={formik.handleSubmit} noValidate>
                        <div className="card-body pt-3">
                            <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-10">
                                <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-warning me-5' />

                                <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                    <div className="mb-3 mb-md-0 fw-semibold">
                                        <h5 className="text-gray-900 fw-semibold">We need your attention!</h5>
                                        <div className="fs-7 text-gray-700 pe-7">Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code</div>
                                    </div>

                                </div>
                            </div>

                            <div className="row">
                                <label className="col-lg-12 col-form-label required fw-semibold fs-6">Purpose of downloading</label>
                                <div className="col-lg-12 fv-row">
                                    <textarea name="remarks" className="form-control form-control-lg form-control-solid mb-lg-0 mb-3" placeholder="Type Remarks">
                                    </textarea>
                                </div>
                            </div>
                        </div>
                        {/*end::Card body*/}
                        <div className='card-footer py-2'>
                            <div className="d-flex justify-content-end">
                                {/*begin::Button*/}

                                <button type="button" onClick={() => confirmationPopup(true)} className="btn btn-primary" >
                                    <span className="indicator-label">{formik?.values?.id ? "Download" : "Download"}</span>
                                    {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                                </button>
                                {/*end::Button*/}
                            </div>
                        </div>
                    </form>
                </div>


            </Modal.Body>

        </Modal>
    </>
    )
}

export { DownloadButton }


